export function AudienceSection() {
  const audiences = [
    "Young footballers serious about long-term professional growth",
    "Parents seeking disciplined football development environments",
    "Football clubs, academies, and sponsors aligned with ethical talent development",
  ]

  return (
    <section className="py-20 bg-ivory">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/20 text-navy text-sm font-medium uppercase tracking-wider mb-6">
          ⚽ Join Our Football Family
        </div>
        <h2 className="text-4xl sm:text-5xl font-semibold text-navy tracking-tight mb-8">
          Who ZOE Football Academy Is For
        </h2>
        <div className="mb-12">
          <img 
            src="/images/who-we-serve.jpg" 
            alt="Football community" 
            className="rounded-lg shadow-lg mx-auto"
          />
        </div>

        <div className="space-y-6">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="p-6 bg-muted rounded border-l-4 border-gold"
            >
              <p className="text-lg text-navy/80 leading-relaxed">
                {audience}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
